import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import SwipeableViews from "react-swipeable-views";
import Checkbox from "@material-ui/core/Checkbox";
import FormLabel from "@material-ui/core/FormLabel";
import { Trans, withTranslation } from "react-i18next";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import KpsEditor from "../editor/KpsEditor";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import { connect } from "react-redux";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import ColourPickerSingleDialog from "../dialog/ColourPickerSingleDialog";
import DecisionTree from "../tree/DecisionTree";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Tooltip from "@material-ui/core/Tooltip";
import ErrorIcon from "@material-ui/icons/Error";
import ReusableSectionsSelectable from "../content/reusable-section/ReusableSectionsSelectable";
import KpsTextField from "../KpsTextField";
import {
  setCustomFields,
} from "../../redux/actions/customFieldsActions";
const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  title: {
    paddingBottom: "16px",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  error: {
    color: theme.palette.error.light,
  },
});
export class AddSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      stage: 0,
      mouseOver: true,
      selected: 0,
      changeColoursDialogOpenContent: false,
      changeColoursDialogOpenTitle: false,
      text: "",
      refSlate: React.createRef(),
      attachmentIds: [],
      tree: {
        label: "Root",
        children: [
          {
            label: "",
            children: [],
            number: 2,
            notes: "",
            selected: false,
            type: "question",
          },
        ],
        number: 1,
        selected: false,
        type: "root",
      },
      titleDirty: false,
      section: {
        type: "text",
        canBeEdited: true,
        classification: 0,
        sectionColumn: "middle",
        name: "",
        attachmentIds: [],
        reusableSectionId: null,
      },
      css: {
        title: {
          bold: false,
          italic: false,
          underline: false,
          fontGeneric: "Serif",
          fontStyle: "Arial",
          fontSize: "20px",
          colour: "#000000",
        },
        content: {
          fontGeneric: "Serif",
          fontStyle: "Arial",
          fontSize: "14px",
          colour: "#000000",
        },
        visible: true,
      },
    };
    this.returnSection = this.returnSection.bind(this);
  }
  componentDidMount() {
    if (this.props.section) {
      this.setState({ section: this.props.section });
      this.setState({ css: JSON.parse(this.props.section.css) });
      if (this.props.section.type === "tree") {
        this.setState({
          tree:
            typeof this.props.section.defaultText === "string" ||
            this.props.section.defaultText instanceof String
              ? JSON.parse(this.props.section.defaultText)
              : this.props.section.defaultText,
        });
      } else {
        this.setState({
          text: this.props.section.defaultText,
          initialSlateContent: this.props.section.defaultText,
        });
      }
    } else {
      this.setState({
        section: {
          ...this.state.section,
          sectionColumn: this.props.sectionColumn,
        },
      });
    }
  }
  render() {
    const { classes, t } = this.props;
    let titleDirty = this.state.titleDirty;
    let section = this.state.section;
    return (
      <div>
        <DialogTitle style={{ paddingBottom: 0 }}>
          {this.props.isEdit ? (
            <Trans i18nKey="new_template_edit_section_header" />
          ) : (
            <Trans i18nKey="new_template_new_section_header" />
          )}
        </DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <KpsTextField
              style={{ marginTop: 0 }}
              inputProps={{ style: { fontSize: 25 } }}
              error={!this.isTitleValid()}
              className={classes.title}
              fullWidth
              required
              label="Section title"
              value={this.state.section.name}
              aria-label="Section title"
              helperText={
                !this.isTitleValid() ? (
                  <Trans i18nKey="create_content_title_required">
                    create_content_title_required
                  </Trans>
                ) : (
                  ""
                )
              }
              onChange={(e) => {
                this.updateTitle(e);
              }}
            />
            <FormLabel>
              <Trans i18nKey="add_section_content_type" />
              <RadioGroup id="typeRadio" row>
                <FormControlLabel
                  onChange={this.changeIsTree}
                  value="text"
                  control={
                    <Radio checked={this.state.section.type === "text"} />
                  }
                  label={t("add_section_content_type_text")}
                />
                <FormControlLabel
                  onChange={this.changeIsTree}
                  value="decision"
                  control={
                    <Radio checked={this.state.section.type === "tree"} />
                  }
                  label={t("global_decision_tree")}
                />
                <FormControlLabel
                  onChange={this.changeIsTree}
                  value="reusable"
                  control={
                    <Radio checked={this.state.section.type === "reusable"} />
                  }
                  label={"Reusable section"}
                />
              </RadioGroup>
            </FormLabel>
          </div>
          <div id="content" style={{ marginTop: 5, marginBottom: 10 }}>
            <FormLabel>Section content</FormLabel>
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              {this.state.section.type === "tree" ? (
                <DecisionTree
                  handleChange={(tree) => this.decisionTreeChange(tree)}
                  title={this.state.section.name}
                  tree={this.state.tree}
                  updateUploadArray={this.addToUploadArray}
                  // setIncomplete={(incomplete) => this.setState({ incomplete })}
                />
              ) : this.state.section.type === "text" ? (
                <KpsEditor
                  newUploadId={this.newUploadId}
                  updateUploadArray={this.updateUploadArray}
                  template
                  resize
                  onChange={this.quillChange}
                  id="section"
                  initialContent={
                    this.props.section && this.props.section.defaultText
                      ? this.props.section.defaultText
                      : this.state.initialSlateContent
                  }
                />
              ) : (
                <ReusableSectionsSelectable
                  reusableSectionSelected={this.reusableSectionSelected}
                  addSection
                />
              )}
            </div>
          </div>
          <div>
            <FormLabel>Section settings</FormLabel>
            <div style={{ display: "flex", marginTop: 10 }}>
              <div style={{ marginRight: 50, width: "20%" }}>
                <FormControl className={classes.formControl} fullWidth>
                  <InputLabel shrink htmlFor="age-label-placeholder">
                    <Trans i18nKey="add_section_classification" />
                  </InputLabel>
                  <Select
                    value={this.state.section.classification}
                    onChange={this.changeClassification}
                    input={
                      <Input name="classification" id="age-label-placeholder" />
                    }
                    name="age"
                  >
                    <MenuItem value={5}>Level 5</MenuItem>
                    <MenuItem value={4}>Level 4</MenuItem>
                    <MenuItem value={3}>Level 3</MenuItem>
                    <MenuItem value={2}>Level 2</MenuItem>
                    <MenuItem value={1}>Level 1</MenuItem>
                    <MenuItem value={0}>Level 0</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <FormGroup>
                  <FormControlLabel
                    value="visible"
                    control={
                      <Checkbox
                        checked={this.state.css.visible}
                        onChange={this.changeVisible}
                      />
                    }
                    label={t("add_section_section_visible")}
                  />
                  <FormControlLabel
                    value="editable"
                    control={
                      <Checkbox
                        checked={this.state.section.canBeEdited}
                        onChange={this.changeEditable}
                      />
                    }
                    label={t("add_section_section_editable")}
                  />
                </FormGroup>
              </div>
            </div>
          </div>
          <div id="options">
            <ExpansionPanel
              expanded={this.state.expanded === "title"}
              onChange={this.handleAccordionChange("title")}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography className={classes.heading}>
                  Title styling
                </Typography>
                <Typography className={classes.secondaryHeading}>
                  Modify the title's font, colour, size and formatting
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <div
                  id="title"
                  style={{ display: "flex", flexDirection: "column", flex: 1 }}
                >
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="age-label-placeholder">
                      <Trans i18nKey="add_section_font_size" />
                    </InputLabel>
                    <Select
                      value={this.state.css.title.fontSize}
                      onChange={this.changeTitleFontSize}
                      input={<Input name="age" id="age-label-placeholder" />}
                      displayEmpty
                      name="age"
                    >
                      <MenuItem value={"30px"}>
                        <Trans i18nKey="add_section_font_size_huge" />
                      </MenuItem>
                      <MenuItem value={"24px"}>
                        <Trans i18nKey="add_section_font_size_large" />
                      </MenuItem>
                      <MenuItem value={"20px"}>
                        <Trans i18nKey="add_section_font_size_medium" />
                      </MenuItem>
                      <MenuItem value={"16px"}>
                        <Trans i18nKey="add_section_font_size_small" />
                      </MenuItem>
                      <MenuItem value={"12px"}>
                        <Trans i18nKey="add_section_font_size_tiny" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <Select
                      open={false}
                      value={this.state.css.title.colour}
                      onChange={this.changeBorderStyle}
                      onClick={this.openColourPickerTitle}
                      input={
                        <Input
                          name="classification"
                          id="age-label-placeholder"
                        />
                      }
                      name="age"
                    >
                      <MenuItem value={this.state.css.title.colour}>
                        {this.state.css.title.colour}
                      </MenuItem>
                    </Select>
                    <ColourPickerSingleDialog
                      open={this.state.changeColoursDialogOpenTitle}
                      onClose={this.changeColoursDialogOpenTitle}
                      onSubmit={this.changeBorderColourTitle}
                    />
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="age-label-placeholder">
                      <Trans i18nKey="add_section_font_style" />
                    </InputLabel>
                    <Select
                      value={this.state.css.title.fontStyle}
                      onChange={this.changeTitleFontStyle}
                      input={<Input name="age" id="age-label-placeholder" />}
                      displayEmpty
                      name="age"
                    >
                      <MenuItem value={"Arial"}>
                        <Trans i18nKey="add_section_font_family_arial" />
                      </MenuItem>
                      <MenuItem value={"Helvetica"}>
                        <Trans i18nKey="add_section_font_family_helvetica" />
                      </MenuItem>
                      <MenuItem value={"Times New Roman"}>
                        <Trans i18nKey="add_section_font_family_time_new_roman" />
                      </MenuItem>
                      <MenuItem value={"Times"}>
                        <Trans i18nKey="add_section_font_family_times" />
                      </MenuItem>
                      <MenuItem value={"Courier New"}>
                        <Trans i18nKey="add_section_font_family_courier_new" />
                      </MenuItem>
                      <MenuItem value={"Courier"}>
                        <Trans i18nKey="add_section_font_family_courier" />
                      </MenuItem>
                      <MenuItem value={"Verdana"}>
                        <Trans i18nKey="add_section_font_family_verdana" />
                      </MenuItem>
                      <MenuItem value={"Georgia"}>
                        <Trans i18nKey="add_section_font_family_georgia" />
                      </MenuItem>
                      <MenuItem value={"Palatino"}>
                        <Trans i18nKey="add_section_font_family_palatino" />
                      </MenuItem>
                      <MenuItem value={"Garamond"}>
                        <Trans i18nKey="add_section_font_family_garamond" />
                      </MenuItem>
                      <MenuItem value={"Arbookmanial"}>
                        <Trans i18nKey="add_section_font_family_bookman" />
                      </MenuItem>
                      <MenuItem value={"Comic Sans Ms"}>
                        <Trans i18nKey="add_section_font_family_comic_sans_ms" />
                      </MenuItem>
                      <MenuItem value={"Trebuchet Ms"}>
                        <Trans i18nKey="add_section_font_family_trebuchet_ms" />
                      </MenuItem>
                      <MenuItem value={"Arial Black"}>
                        <Trans i18nKey="add_section_font_family_arial_black" />
                      </MenuItem>
                      <MenuItem value={"Impact"}>
                        <Trans i18nKey="add_section_font_family_impact" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="age-label-placeholder">
                      <Trans i18nKey="add_section_font_generic" />
                    </InputLabel>
                    <Select
                      value={this.state.css.title.fontGeneric}
                      onChange={this.changeTitleFontGeneric}
                      input={<Input name="age" id="age-label-placeholder" />}
                      displayEmpty
                      name="age"
                    >
                      <MenuItem value={"Serif"}>
                        <Trans i18nKey="add_section_font_style_serif" />
                      </MenuItem>
                      <MenuItem value={"Sans-serif"}>
                        <Trans i18nKey="add_section_font_style_sans_serif" />
                      </MenuItem>
                      <MenuItem value={"Monospace"}>
                        <Trans i18nKey="add_section_font_style_monospace" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <FormGroup>
                    <FormControlLabel
                      value="bold"
                      control={
                        <Checkbox
                          checked={this.state.css.title.bold}
                          onChange={this.changeBold}
                        />
                      }
                      label={t("add_section_title_bold")}
                    />
                    <FormControlLabel
                      value="italic"
                      control={
                        <Checkbox
                          checked={this.state.css.title.italic}
                          onChange={this.changeItalic}
                        />
                      }
                      label={t("add_section_title_italic")}
                    />
                    <FormControlLabel
                      value="underline"
                      control={
                        <Checkbox
                          checked={this.state.css.title.underline}
                          onChange={this.changeUnderline}
                        />
                      }
                      label={t("add_section_title_underline")}
                    />
                  </FormGroup>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel
              expanded={this.state.expanded === "content"}
              onChange={this.handleAccordionChange("content")}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography className={classes.heading}>
                  Content styling
                </Typography>
                <Typography className={classes.secondaryHeading}>
                  Modify the content's font, colour and size
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <div
                  id="content"
                  style={{ display: "flex", flexDirection: "column", flex: 1 }}
                >
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="age-label-placeholder">
                      <Trans i18nKey="add_section_font_size" />
                    </InputLabel>
                    <Select
                      value={this.state.css.content.fontSize}
                      onChange={this.changeContentFontSize}
                      input={<Input name="age" id="age-label-placeholder" />}
                      displayEmpty
                      name="age"
                      aria-label="Content font size"
                    >
                      <MenuItem value={"18px"} aria-label="18px">
                        <Trans i18nKey="add_section_font_size_huge" />
                      </MenuItem>
                      <MenuItem value={"16px"}>
                        <Trans i18nKey="add_section_font_size_large" />
                      </MenuItem>
                      <MenuItem value={"14px"}>
                        <Trans i18nKey="add_section_font_size_medium" />
                      </MenuItem>
                      <MenuItem value={"12px"}>
                        <Trans i18nKey="add_section_font_size_small" />
                      </MenuItem>
                      <MenuItem value={"10px"}>
                        <Trans i18nKey="add_section_font_size_tiny" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <Select
                      open={false}
                      value={this.state.css.content.colour}
                      onChange={this.changeBorderStyle}
                      onClick={this.openColourPickerContent}
                      input={
                        <Input
                          name="classification"
                          id="age-label-placeholder"
                        />
                      }
                      name="age"
                      aria-label="Content colour"
                    >
                      <MenuItem value={this.state.css.content.colour}>
                        {this.state.css.content.colour}
                      </MenuItem>
                    </Select>
                    <ColourPickerSingleDialog
                      open={this.state.changeColoursDialogOpenContent}
                      onClose={this.openColourPickerContent}
                      onSubmit={this.changeBorderColourContent}
                    />
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="age-label-placeholder">
                      <Trans i18nKey="add_section_font_style" />
                    </InputLabel>
                    <Select
                      value={this.state.css.content.fontStyle}
                      onChange={this.changeContentFontStyle}
                      input={<Input name="age" id="age-label-placeholder" />}
                      displayEmpty
                      name="age"
                      aria-label="Content font style"
                    >
                      <MenuItem value={"Arial"}>
                        <Trans i18nKey="add_section_font_family_arial" />
                      </MenuItem>
                      <MenuItem value={"Helvetica"}>
                        <Trans i18nKey="add_section_font_family_helvetica" />
                      </MenuItem>
                      <MenuItem value={"Times New Roman"}>
                        <Trans i18nKey="add_section_font_family_time_new_roman" />
                      </MenuItem>
                      <MenuItem value={"Times"}>
                        <Trans i18nKey="add_section_font_family_times" />
                      </MenuItem>
                      <MenuItem value={"Courier New"}>
                        <Trans i18nKey="add_section_font_family_courier_new" />
                      </MenuItem>
                      <MenuItem value={"Courier"}>
                        <Trans i18nKey="add_section_font_family_courier" />
                      </MenuItem>
                      <MenuItem value={"Verdana"}>
                        <Trans i18nKey="add_section_font_family_verdana" />
                      </MenuItem>
                      <MenuItem value={"Georgia"}>
                        <Trans i18nKey="add_section_font_family_georgia" />
                      </MenuItem>
                      <MenuItem value={"Palatino"}>
                        <Trans i18nKey="add_section_font_family_palatino" />
                      </MenuItem>
                      <MenuItem value={"Garamond"}>
                        <Trans i18nKey="add_section_font_family_garamond" />
                      </MenuItem>
                      <MenuItem value={"Arbookmanial"}>
                        <Trans i18nKey="add_section_font_family_bookman" />
                      </MenuItem>
                      <MenuItem
                        value={"Comic Sans Ms"}
                        aria-label="Comic sans ms"
                      >
                        <Trans i18nKey="add_section_font_family_comic_sans_ms" />
                      </MenuItem>
                      <MenuItem value={"Trebuchet Ms"}>
                        <Trans i18nKey="add_section_font_family_trebuchet_ms" />
                      </MenuItem>
                      <MenuItem value={"Arial Black"}>
                        <Trans i18nKey="add_section_font_family_arial_black" />
                      </MenuItem>
                      <MenuItem value={"Impact"}>
                        <Trans i18nKey="add_section_font_family_impact" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="age-label-placeholder">
                      <Trans i18nKey="add_section_font_generic" />
                    </InputLabel>
                    <Select
                      value={this.state.css.content.fontGeneric}
                      onChange={this.changeContentFontGeneric}
                      input={<Input name="age" />}
                      displayEmpty
                      name="age"
                      aria-label="Content font generic"
                    >
                      <MenuItem value={"Serif"}>
                        <Trans i18nKey="add_section_font_style_serif" />
                      </MenuItem>
                      <MenuItem value={"Sans-serif"}>
                        <Trans i18nKey="add_section_font_style_sans_serif" />
                      </MenuItem>
                      <MenuItem value={"Monospace"} aria-label="Monospace">
                        <Trans i18nKey="add_section_font_style_monospace" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.close}>
            <Trans i18nKey="global_cancel" />
          </Button>
          <Button onClick={this.returnSection} disabled={!this.isTitleValid()}>
            <Trans i18nKey={this.props.isEdit ? "global_save" : "global_add"} />
          </Button>
          {/* {this.state.incomplete && this.state.section.isTree &&
            <Tooltip
              title={"Decision tree incomplete"}
              aria-label={"Decision tree incomplete"}
            >
              <ErrorIcon className={classes.error} />
            </Tooltip>
          } */}
        </DialogActions>
      </div>
    );
  }
  updateUploadArray = (array) => {
    this.setState({ attachmentIds: array });
  };
  addToUploadArray = (array) => {
    this.setState({ attachmentIds:  [...new Set([...this.state.attachmentIds, array])] });
  };
  newUploadId = (response) => {
    let attachments = this.state.attachmentIds.splice(0);
    attachments.push(Number(response));
    this.setState({
      section: { ...this.state.section, attachmentIds: attachments },
    });
  };
  changeBorderColourContent = (value) => {
    this.setState({
      css: {
        ...this.state.css,
        content: { ...this.state.css.content, colour: value },
      },
      changeColoursDialogOpenContent: false,
    });
  };
  handleAccordionChange = (panel) => (e, isExpanded) => {
    this.setState({ expanded: isExpanded ? panel : false });
  };
  changeBorderColourTitle = (value) => {
    this.setState({
      css: {
        ...this.state.css,
        title: { ...this.state.css.title, colour: value },
      },
      changeColoursDialogOpenTitle: false,
    });
  };
  openColourPickerContent = () => {
    this.setState({
      changeColoursDialogOpenContent: !this.state
        .changeColoursDialogOpenContent,
    });
  };
  openColourPickerTitle = () => {
    this.setState({
      changeColoursDialogOpenTitle: !this.state.changeColoursDialogOpenTitle,
    });
  };
  decisionTreeChange = (tree) => {
    this.setState({ tree });
  };
  reusableSectionSelected = (selected) => {
    //add here CF addition
    let newCustomFields = [ ...this.props.currentCustomFields, ...selected.customFieldsRVOs ];
    this.props.setCustomFields(newCustomFields);
    this.setState({
      section: {
        ...this.state.section,
        reusableSectionId: selected.reusableSectionId,
        customFieldsRVOs: selected.customFieldsRVOs,
      },
      text: selected.content,
    });
  };
  quillChange = (event) => {
    this.setState({ text: event });
  };
  changeIsTree = (event) => {
    if (event.target.value === "decision") {
      this.setState({ section: { ...this.state.section, type: "tree" } });
    } else if (event.target.value === "text") {
      this.setState({ section: { ...this.state.section, type: "text" } });
    } else {
      this.setState({ section: { ...this.state.section, type: "reusable" } });
    }
  };
  positionChanged = (event, value) => {
    this.setState({ section: { ...this.state.section, sectionColumn: value } });
  };
  changeVisible = (event, value) => {
    this.setState({ css: { ...this.state.css, visible: value } });
  };
  changeEditable = (event, value) => {
    this.setState({ section: { ...this.state.section, canBeEdited: value } });
  };
  updateTitle = (title) => {
    this.setState({
      section: { ...this.state.section, name: title.target.value },
    });
  };
  changeBold = (event, value) => {
    this.setState({
      css: {
        ...this.state.css,
        title: { ...this.state.css.title, bold: value },
      },
    });
  };
  changeItalic = (event, value) => {
    this.setState({
      css: {
        ...this.state.css,
        title: { ...this.state.css.title, italic: value },
      },
    });
  };
  changeUnderline = (event, value) => {
    this.setState({
      css: {
        ...this.state.css,
        title: { ...this.state.css.title, underline: value },
      },
    });
  };
  changeClassification = (event) => {
    this.setState({
      section: { ...this.state.section, classification: event.target.value },
    });
  };
  changeSelected = (event, value) => {
    this.setState({ selected: value });
  };
  changeContentFontGeneric = (event) => {
    this.setState({
      css: {
        ...this.state.css,
        content: { ...this.state.css.content, fontGeneric: event.target.value },
      },
    });
  };
  changeContentFontStyle = (event) => {
    this.setState({
      css: {
        ...this.state.css,
        content: { ...this.state.css.content, fontStyle: event.target.value },
      },
    });
  };
  changeContentFontSize = (event) => {
    this.setState({
      css: {
        ...this.state.css,
        content: { ...this.state.css.content, fontSize: event.target.value },
      },
    });
  };
  changeTitleFontGeneric = (event) => {
    this.setState({
      css: {
        ...this.state.css,
        title: { ...this.state.css.title, fontGeneric: event.target.value },
      },
    });
  };
  changeTitleFontStyle = (event) => {
    this.setState({
      css: {
        ...this.state.css,
        title: { ...this.state.css.title, fontStyle: event.target.value },
      },
    });
  };
  changeTitleFontSize = (event) => {
    this.setState({
      css: {
        ...this.state.css,
        title: { ...this.state.css.title, fontSize: event.target.value },
      },
    });
  };
  setCss(e) {
    if (e.css) {
      this.setState({ css: JSON.parse(e.css) });
    }
  }

  changeStage = (event, value) => {
    this.setState({ stage: value });
  };

  isTitleValid() {
    let section = this.state.section;
    return section.name && section.name.length > 0;
  }

  returnSection() {
    let section = { ...this.state.section };
    if (section.type === "tree") {
      section.defaultText = JSON.stringify(this.state.tree);
    } else {
      section.defaultText = this.state.text.slice(0);
    }
    section.isSelfService = false;
    section.isAgent = false;
    section.isMobile = false;
    section.information = "";
    var css = Object.assign({}, this.state.css);
    section.css = JSON.stringify(css);
    section.attachmentIds = this.state.attachmentIds;
    this.props.addSection(section);
  }
}
const mapDispatchToProps = {
  setCustomFields,
};
const mapStateToProps = (state) => ({
  currentCustomFields: state.customFields.currentCustomFields,
});
export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(AddSection))
);
